var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-page-shell',{attrs:{"logo-alt":"Back to home page","logo-href":"/","logo-responsive":"/logo.svg","logo":"/logo.svg","to":_vm.HOME_URL}},[_c('page-not-found',{attrs:{"message":_vm.message}}),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }